import { render, staticRenderFns } from "./MetadataPanel.vue?vue&type=template&id=21650b52&"
import script from "./MetadataPanel.vue?vue&type=script&lang=js&"
export * from "./MetadataPanel.vue?vue&type=script&lang=js&"
import style0 from "./MetadataPanel.vue?vue&type=style&index=0&id=21650b52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports